import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  /**
   * The onLangChange subscription to update the component if the language change.
   *
   * @type {any}
   */
  onLangChange: Subscription = undefined;

  /**
   * The constructor.
   *
   * @param Document injection through angular common DOCUMENT
   * @param translate the translate service
   */
  constructor(@Inject(DOCUMENT) private document: Document, public translate: TranslateService) { }

  ngOnInit() {
    this.updateLanguage();
    this.onLangChange = this.translate.onLangChange.subscribe(() => {
      this.updateLanguage();
    });
  }

  ngOnDestroy() {
    if (this.onLangChange !== undefined) {
      this.onLangChange.unsubscribe();
    }
  }

  /**
   * Update the language in the lang attribute of the html element.
   */
  updateLanguage(): void {
    this.document.documentElement.lang = this.translate.currentLang;
  }

}
